export enum AddressType {
  Unknown,
  Physical,
  Mailing
}
